import request from '@/utils/request'


// 查询发现-文章频道列表
export function listDiscoverPostChannel(query) {
  return request({
    url: '/discovery/discover/post/channel/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现-文章频道分页
export function pageDiscoverPostChannel(query) {
  return request({
    url: '/discovery/discover/post/channel/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现-文章频道详细
export function getDiscoverPostChannel(data) {
  return request({
    url: '/discovery/discover/post/channel/detail',
    method: 'get',
    params: data
  })
}

// 新增发现-文章频道
export function addDiscoverPostChannel(data) {
  return request({
    url: '/discovery/discover/post/channel/add',
    method: 'post',
    data: data
  })
}

// 修改发现-文章频道
export function updateDiscoverPostChannel(data) {
  return request({
    url: '/discovery/discover/post/channel/edit',
    method: 'post',
    data: data
  })
}

// 删除发现-文章频道
export function delDiscoverPostChannel(data) {
  return request({
    url: '/discovery/discover/post/channel/delete',
    method: 'post',
    data: data
  })
}
